module.exports = __webpack_public_path__ + "static/media/B_F03.58a3200c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/B_F03.png
// module id = 117
// module chunks = 0